// CALIBER'S MARK (owner call 2026-10-28: "use this logo for the top left and for the splash … one source of truth"):
// Caliber Cards 09 · Fall, a card dropping onto its base, its earlier places left as ghosts that fade up from where it
// landed (components/caliberMarkFigure, generated from the pack). The rail's mark, the site's, the reader's, the error
// page's and the splash's (CaliberMarkSplash, which draws it layer by layer): one figure, one ink.

import { FALL, type MarkLayer } from './caliberMarkFigure';

/** The mark's layers, drawn in order: the base, the ghosts far to near, the card landed. */
export const MARK_PARTS = FALL;

/** The figure's box on its 200-unit canvas, its stroke's reach left out. */
const xs = FALL.flatMap((l) => [...l.lines.flatMap(([x1, , x2]) => [x1, x2]), ...l.dots.map(([x]) => x)]);
const ys = FALL.flatMap((l) => [...l.lines.flatMap(([, y1, , y2]) => [y1, y2]), ...l.dots.map(([, y]) => y)]);
export const MARK_BOX = { x: Math.min(...xs), y: Math.min(...ys), w: Math.max(...xs) - Math.min(...xs), h: Math.max(...ys) - Math.min(...ys) };

/** One layer: its lines at its weight and its nodes, in its own ink. Strokes keep their weight in screen pixels whatever
 *  the size, so the ghosts stay hairlines on the splash as on the rail. */
export const MarkPart = ({ layer }: { layer: MarkLayer }) => <g opacity={layer.op}>
  {layer.lines.map(([x1, y1, x2, y2], i) =>
    <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} strokeWidth={layer.w} vectorEffect="non-scaling-stroke" />)}
  {layer.dots.map(([cx, cy, r], i) => <circle key={`d${i}`} cx={cx} cy={cy} r={r} fill="currentColor" stroke="none" />)}
</g>;

/** The mark. `clear`: the margin an app mark keeps inside the rail's mark cell, which the kit sizes to the rail's
 *  width; otherwise the box is the drawing, so the mark's ink meets the edge it is set on. */
export function CaliberMark({ clear = false }: { clear?: boolean }) {
  const pad = clear ? 10 : 2, { x, y, w, h } = MARK_BOX;
  const side = Math.max(w, h) + 2 * pad;
  return (
    <svg className="caliber-mark" viewBox={`${x + w / 2 - side / 2} ${y + h / 2 - side / 2} ${side} ${side}`} fill="none" stroke="currentColor"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {MARK_PARTS.map((layer, k) => <MarkPart key={k} layer={layer} />)}
    </svg>
  );
}
